import { Injectable } from '@angular/core';
import { SiteServiceBase } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class SiteDataService extends SiteServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
